import { render, staticRenderFns } from "./pageMyGoal.vue?vue&type=template&id=1e620a5e&scoped=true"
import script from "./pageMyGoal.vue?vue&type=script&lang=js"
export * from "./pageMyGoal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e620a5e",
  null
  
)

export default component.exports